import styles from "./styles.module.scss";

export const Attachments = () => {
  return (
    <div className={styles.attachmentsContainer}>
      <div className={styles.attachmentsHeading}>
        <h3>Attachments</h3>
        <span>4</span>
      </div>
      <div className={styles.attachmentsList}>
        {[1, 2, 3, 4].map(() => (
          <div className={styles.singleAttachment}></div>
        ))}
      </div>
    </div>
  );
};
